/* eslint-disable no-nested-ternary */
/* eslint-disable complexity */

/* eslint-disable react/jsx-max-depth */

/* eslint-disable max-lines */
/* eslint-disable max-lines-per-function */
/* eslint-disable react/jsx-no-bind */
import {
  AddButton,
  Button,
  Checkbox,
  DeleteButton,
  InputText,
  Modal,
  Pill,
  Toggle
} from "@bluframe/blublocks"
import ActionsAndInfoSideBar from "components/ActionsAndInfoSideBar"
import Autosuggest from "components/Autosuggest"
import ConfirmModal from "components/ConfirmModal"
import EditableField from "components/EditableField"
import {
  FieldLabel,
  FieldLabelAndValue,
  FieldRow,
  FieldValue
} from "components/Fields/styled"
import GuardrailMessage from "components/HomeVideos/Item/GuardrailMessage"
import ImageSelectorAndCarousel from "components/ImageSelectorAndCarousel"
import InputDate from "components/inputs/Date"
import {
  Form,
  InputAndButton,
  Main,
  Top
} from "components/List/ItemView/styled"
import Typography from "components/Typography"
import formatDate from "helpers/dates/formatDate"
import { useEffect, useRef } from "react"

import { ComponentProps } from "."
import {
  GuardrailActions,
  GuardrailModalContent,
  StoreLink,
  StoreLinks,
  StoreLinksControls,
  StoreLinksUl
} from "./styled"

const IMDB_ID_HELPER_TEXT = "Format: tt1234567 or tt12345678"

const Item = ({
  bulkToggleChecked = false,
  bulkToggleDisabled = true,
  actionButtonLabel,
  actionButtonOnClick,
  deleteGuardrailDependencies,
  deleteGuardrailMessage,
  editionsRef,
  isActionButtonLoading,
  isAdd,
  isAdmin,
  isDeleteLoading,
  isEditMode,
  isEditor,
  isLabelsSuggestionsLoading,
  isStoresSuggestionsLoading,
  isModalOpen,
  isUHDRef,
  imdbIdError,
  imdbIdRef,
  item,
  labels,
  modalContent,
  nameRef,
  onAddStoreLink,
  onBulkToggleChange,
  onDeleteGuardrailDismiss,
  onDeleteStoreLink,
  onGetLabelsSuggestions,
  onGetStoresSuggestions,
  onModalClose,
  onModalConfirmOpen,
  onModalDeleteConfirm,
  onModalPublishToggleConfirm,
  onSelectLabelId,
  onSelectStoreId,
  onInferScreenshotCredit,
  onRegenerateScreenshotMetadataField,
  onSetReleaseDate,
  onSetSelectedImages,
  onSetSelectedScreenshots,
  onStoreUrlChange,
  onSubmit,
  onResetImdbIdError,
  outlinedButtonLabel,
  outlinedButtonOnClick,
  releaseDate,
  selectedImages,
  selectedScreenshots,
  selectedLabelId,
  selectedStoreIds,
  storeOptionsById,
  storeLinkRefs,
  storeLinks,
  stores
}: ComponentProps) => {
  const guardrailHasDependencies =
    (deleteGuardrailDependencies?.length ?? 0) > 0
  const guardrailPresentedRef = useRef(false)

  const handleBulkToggleChange = (checked: boolean) => {
    onBulkToggleChange?.(checked)
  }

  useEffect(() => {
    if (guardrailHasDependencies && !guardrailPresentedRef.current) {
      onModalConfirmOpen("deleteGuardrail")()
      guardrailPresentedRef.current = true
      return
    }

    if (!guardrailHasDependencies) {
      guardrailPresentedRef.current = false
    }
  }, [guardrailHasDependencies, onModalConfirmOpen])

  const handleGuardrailClose = () => {
    onDeleteGuardrailDismiss?.()
    onModalClose()
  }

  return (
    <Form aria-label="Home Video Item Form" onSubmit={onSubmit}>
      <Top>
        <Main>
          <FieldRow $items={2}>
            {item?.id ? (
              <FieldLabelAndValue>
                <FieldLabel id="id">{"ID"}</FieldLabel>

                <FieldValue aria-labelledby="id">{item.id}</FieldValue>
              </FieldLabelAndValue>
            ) : null}

            {isEditMode ? (
              <Toggle
                defaultChecked={item?.isUHD}
                inputId="isUHD"
                label="Is 4K Blu-ray"
                name="isUHD"
                ref={isUHDRef}
              />
            ) : (
              <FieldLabelAndValue>
                <FieldLabel id="isUHD">{"Is 4K Blu-ray"}</FieldLabel>

                <FieldValue aria-labelledby="isUHD">
                  {item?.isUHD ? "Yes" : "No"}
                </FieldValue>
              </FieldLabelAndValue>
            )}
          </FieldRow>

          <FieldRow $items={2}>
            <EditableField
              fieldRef={nameRef}
              id="name"
              isEditMode={isEditMode}
              label="Name"
              name="name"
              value={item?.name ?? ""}
            />

            <EditableField
              fieldRef={editionsRef}
              id="editions"
              isEditMode={isEditMode}
              label="Editions"
              name="editions"
              value={item?.editions?.join(", ") ?? ""}
            />
          </FieldRow>

          {isAdd ? (
            <FieldRow $items={2}>
              <EditableField
                error={Boolean(imdbIdError)}
                errorText={imdbIdError ?? undefined}
                fieldRef={imdbIdRef}
                id="imdbId"
                infoText={IMDB_ID_HELPER_TEXT}
                isEditMode={isEditMode}
                label="IMDb ID"
                name="imdbId"
                onChange={onResetImdbIdError}
                value={item?.mas?.imdbId ?? ""}
              />
            </FieldRow>
          ) : null}

          <FieldRow $items={2}>
            {isEditMode ? (
              <InputDate
                label="Release Date"
                onChange={onSetReleaseDate}
                value={releaseDate}
              />
            ) : (
              <FieldLabelAndValue>
                <FieldLabel>{"Release Date"}</FieldLabel>

                <FieldValue>
                  {item?.releaseDate
                    ? formatDate(item.releaseDate).fullDate
                    : undefined}
                </FieldValue>
              </FieldLabelAndValue>
            )}
          </FieldRow>

          <ImageSelectorAndCarousel
            images={item?.images ?? undefined}
            isEditMode={isEditMode}
            onSetSelectedImages={onSetSelectedImages}
            selectedImages={selectedImages}
          />

          <ImageSelectorAndCarousel
            images={item?.screenshots ?? undefined}
            isEditMode={isEditMode}
            mediaLabel="Screenshots"
            onInferImageCredit={onInferScreenshotCredit}
            onRegenerateScreenshotMetadataField={
              onRegenerateScreenshotMetadataField
            }
            onSetSelectedImages={onSetSelectedScreenshots}
            selectedImages={selectedScreenshots}
            showScreenshotMetadataInputs={Boolean(isEditMode && !isAdd)}
          />

          <StoreLinks aria-label="Store Links" role="region">
            <InputAndButton>
              <FieldLabel>{"Store Links"}</FieldLabel>

              {isEditMode ? (
                <StoreLinksControls>
                  <Toggle
                    checked={bulkToggleChecked}
                    disabled={bulkToggleDisabled}
                    inputId="storeLinksBulkToggle"
                    label="Pre-order all store links"
                    name="storeLinksBulkToggle"
                    onChange={handleBulkToggleChange}
                  />

                  <AddButton label="Add StoreLink" onClick={onAddStoreLink} />
                </StoreLinksControls>
              ) : null}
            </InputAndButton>

            <StoreLinksUl aria-label="Store Links List">
              {storeLinks.map((storeLink, index) => {
                const selectedStoreIdForIndex = selectedStoreIds?.find(
                  (id) => id.index === index
                )?.id
                const fallbackStoreOption = selectedStoreIdForIndex
                  ? storeOptionsById[selectedStoreIdForIndex]
                  : undefined
                const combinedSuggestions = fallbackStoreOption
                  ? [fallbackStoreOption, ...stores]
                  : stores

                const storeSuggestions = combinedSuggestions.filter(
                  (suggestion, suggestionIndex, array) =>
                    array.findIndex(
                      (candidate) => candidate.id === suggestion.id
                    ) === suggestionIndex
                )
                const selectedStoreName = selectedStoreIdForIndex
                  ? (fallbackStoreOption?.name ??
                    stores.find((store) => store.id === selectedStoreIdForIndex)
                      ?.name ??
                    storeLink.store?.url ??
                    storeLink.url)
                  : (storeLink.store?.url ?? storeLink.url)
                const priceValue = storeLink.priceFormatted
                const currencyValue = storeLink.currencyCode
                const stockValue =
                  storeLink.isInStock === true
                    ? "In stock"
                    : storeLink.isInStock === false
                      ? "Out of stock"
                      : undefined

                const isShowPriceRow = Boolean(
                  priceValue || currencyValue || stockValue
                )
                return (
                  <li
                    key={
                      storeLink.localKey ??
                      storeLink.id ??
                      `storeLink-${storeLink.store?.id ?? index}`
                    }
                  >
                    {isEditMode ? (
                      <InputAndButton>
                        <StoreLink>
                          <Autosuggest
                            hasSelectedIcon
                            inputId={`search-storeLink-${index}`}
                            isLoading={isStoresSuggestionsLoading}
                            label="Search for a Store"
                            onGetSuggestions={onGetStoresSuggestions}
                            onSuggestionClick={onSelectStoreId(index)}
                            suggestions={storeSuggestions}
                            value={selectedStoreIdForIndex}
                          />

                          <InputText
                            defaultValue={storeLink.url}
                            inputId={`storeLink-${index}-url`}
                            label="Url"
                            name="url"
                            onChange={onStoreUrlChange(index)}
                            ref={storeLinkRefs[index]?.url}
                          />

                          <Checkbox
                            defaultIsChecked={Boolean(storeLink.isPreOrder)}
                            inputId={`storeLink-${index}-isPreOrder`}
                            key={`${
                              storeLink.localKey ??
                              storeLink.id ??
                              `storeLink-${storeLink.store?.id ?? index}`
                            }-${storeLink.isPreOrder ? "pre" : "buy"}`}
                            label="Is Pre-Order"
                            name="isPreOrder"
                            ref={storeLinkRefs[index]?.isPreOrder}
                          />

                          {isShowPriceRow ? (
                            <FieldRow $items={3}>
                              <FieldLabelAndValue>
                                <FieldLabel>{"Price"}</FieldLabel>

                                <FieldValue>{priceValue}</FieldValue>
                              </FieldLabelAndValue>

                              <FieldLabelAndValue>
                                <FieldLabel>{"Currency"}</FieldLabel>

                                <FieldValue>{currencyValue}</FieldValue>
                              </FieldLabelAndValue>

                              <FieldLabelAndValue>
                                <FieldLabel>{"Stock"}</FieldLabel>

                                <FieldValue>{stockValue}</FieldValue>
                              </FieldLabelAndValue>
                            </FieldRow>
                          ) : null}
                        </StoreLink>

                        <DeleteButton
                          label="Delete"
                          onClick={onDeleteStoreLink(index)}
                        />
                      </InputAndButton>
                    ) : (
                      <FieldRow>
                        <FieldLabelAndValue>
                          <FieldLabel>{"Store"}</FieldLabel>

                          <FieldValue>{selectedStoreName}</FieldValue>
                        </FieldLabelAndValue>

                        <FieldLabelAndValue>
                          <FieldLabel>{"Url"}</FieldLabel>

                          <FieldValue>{storeLink.url}</FieldValue>
                        </FieldLabelAndValue>

                        <FieldLabelAndValue style={{ justifyItems: "start" }}>
                          {storeLink.isPreOrder ? (
                            <Pill label="Pre-Order" size="sm" tone="warning" />
                          ) : (
                            <Pill label="Buy" size="sm" tone="success" />
                          )}
                        </FieldLabelAndValue>

                        {isShowPriceRow ? (
                          <FieldRow $items={3}>
                            <FieldLabelAndValue>
                              <FieldLabel>{"Price"}</FieldLabel>

                              <FieldValue>{priceValue}</FieldValue>
                            </FieldLabelAndValue>

                            <FieldLabelAndValue>
                              <FieldLabel>{"Currency"}</FieldLabel>

                              <FieldValue>{currencyValue}</FieldValue>
                            </FieldLabelAndValue>

                            <FieldLabelAndValue>
                              <FieldLabel>{"Stock"}</FieldLabel>

                              <FieldValue>{stockValue}</FieldValue>
                            </FieldLabelAndValue>
                          </FieldRow>
                        ) : null}
                      </FieldRow>
                    )}
                  </li>
                )
              })}
            </StoreLinksUl>
          </StoreLinks>
        </Main>

        <ActionsAndInfoSideBar
          actionButtonLabel={actionButtonLabel}
          actionButtonOnClick={actionButtonOnClick}
          isActionButtonLoading={isActionButtonLoading}
          isAdd={isAdd}
          isAdmin={isAdmin}
          isEditMode={isEditMode}
          isEditor={isEditor}
          isLinkedItemsSuggestionsLoading={isLabelsSuggestionsLoading}
          item={
            item
              ? {
                  createdAt: item.createdAt,
                  isPublished: item.isPublished,
                  linkedItem: item.label
                    ? { id: item.label.id, name: item.label.vendor.name }
                    : undefined,
                  publishedAt: item.publishedAt,
                  updatedAt: item.updatedAt
                }
              : undefined
          }
          linkedItemLabel="Label"
          linkedItemPath="/vendors/labels"
          linkedItems={labels}
          linkedItemsSearchInputId="search-label"
          linkedItemsSearchLabel="Search for a Label"
          onGetLinkedItemsSuggestions={onGetLabelsSuggestions}
          onModalConfirmOpen={onModalConfirmOpen}
          onSelectLinkedItemId={onSelectLabelId}
          outlinedButtonLabel={outlinedButtonLabel}
          outlinedButtonOnClick={outlinedButtonOnClick}
          selectedLinkedItemId={selectedLabelId}
        />
      </Top>

      <Modal isOpen={isModalOpen} onClose={onModalClose}>
        {modalContent === "deleteConfirm" && (
          <ConfirmModal
            isLoading={isDeleteLoading}
            message="Are you sure you want to delete?"
            onClose={onModalClose}
            onConfirm={onModalDeleteConfirm}
          />
        )}

        {modalContent === "publishConfirm" && (
          <ConfirmModal
            message={`Are you sure you want to ${
              item?.isPublished ? "unpublish" : "publish"
            }?`}
            onClose={onModalClose}
            onConfirm={onModalPublishToggleConfirm}
          />
        )}

        {modalContent === "deleteGuardrail" && guardrailHasDependencies ? (
          <GuardrailModalContent role="alert">
            <Typography.H5>
              {"Linked items must be removed first"}
            </Typography.H5>

            <GuardrailMessage
              dependencies={deleteGuardrailDependencies ?? []}
              message={deleteGuardrailMessage}
            />

            <GuardrailActions>
              <Button label="Close" onClick={handleGuardrailClose} outlined />

              <Button disabled label="Delete" />
            </GuardrailActions>
          </GuardrailModalContent>
        ) : null}
      </Modal>
    </Form>
  )
}

export default Item
